import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ToolCarsSelectorService {

  // variables para visibilidad de paneles
  public isCarSelectionToolVisible: boolean = false;
  public isCarSelectionToolTipVisible: boolean = false;
  
  startDate: Date;
  endDate: Date;

  private intersectedFeatures$: Subject<any> = new Subject<any>();
  private AvailabilityButton$: Subject<boolean> = new Subject<boolean>();

  constructor() {

  }

  getIntersectedFeatures(): any {
    return this.intersectedFeatures$.asObservable();
  }

  setIntersectedFeatures(resp){
    this.intersectedFeatures$.next(resp);
  }

  getAvailabilityButton(): any {
    return this.AvailabilityButton$.asObservable();
  }

  setAvailabilityButton(resp){
    this.AvailabilityButton$.next(resp);
  }

}
